/**
 * 路由封装
 * 路由懒加载方式一：
 *    1. component: resolve => require(['../pages/Index.vue'],resolve)  // 路由懒加载
 * 路由懒加载方式二：
 *    1. 需要添加 syntax-dynamic-import (opens new window)插件，才能使 Babel 可以正确地解析语法,`cnpm install --save-dev @babel/plugin-syntax-dynamic-import`
 *    2. component: () => import('../pages/Cart.vue'), // 路由懒加载
 */
// 导入vue和vue-router
import Vue from 'vue'
import Router from 'vue-router'
// 导入页面组件
// import Login from '../pages/Login'
import Home from '../pages/Home'
import Index from '../pages/Index'
// import Product from '../pages/Product'
import Detail from '../pages/Detail'
import Receipt from '../pages/Receipt'
import Reply from '../pages/Reply'
import SubmitRes from '../pages/SubmitRes'
import ResList from '../pages/ResList'
import Commit  from '../pages/Commit'
import Store from '../pages/Store'
import GoodDetail from '../pages/GoodDetail'
import VueCropper from '../pages/VueCropper'
// 加载路由插件
Vue.use(Router)
// 导出路由
export default new Router({
  // 路由规则
  routes: [
    // 首页
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: '/index', // 重定向
      // 子路由
      children: [
        {
          path: 'index',
          name: 'index',
          component: Index,
        },
        {
          path: 'product/:id', // 动态路由
          name: 'product',
          // component: Product,
          // component: resolve => require(['../pages/Product.vue'],resolve), // 路由懒加载
          component: () => import('../pages/Product.vue') // 路由懒加载
        }
      ]
    },
    {
      path: '/GoodDetail/:id/:img',
      name: 'GoodDetail',
      component: GoodDetail,
    },
    {
      path: '/VueCropper/:id',
      name: 'VueCropper',
      component: VueCropper,
    },
    {
      path: '/Store',
      name: 'Store',
      component: Store,
    },
    {
      path: '/detail/:id',
      name: 'detail',
      component: Detail,
    },
    {
      path: '/SubmitRes/:id',
      name: 'SubmitRes',
      component: SubmitRes,
    },
    {
      path: '/Commit',
      name: 'Commit',
      component: Commit,
    },
    {
      path: '/ResList',
      name: 'ResList',
      component: ResList,
    },
    {
      path: '/Receipt/:id',
      name: 'Receipt',
      component: Receipt,
    },
    {
      path: '/Reply',
      name: 'Reply',
      component: Reply,
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      // component: Login
      component: () => import('../pages/Login.vue') // 路由懒加载
    },
    // 订单
    {
      path: '/community',
      name: 'community',
      component: () => import('../pages/Community.vue'),
    }
  ]
})